module.exports = __webpack_public_path__ + "static/1-639282b4a0080f211087ae8fd6cca8c6.jpg";